import Vue from 'vue';

import { RequiredChangeIbanService } from '~/app/features/required-change-iban/services/required-change-iban.service';
import { UploadPhotoService } from '~/app/modules/biometry/services/upload-photo.service';
import { BiometryService } from '~/app/modules/biometry/services/biomerty.service';

export default function services(ctx, inject) {
  const requiredChangeIbanService = new RequiredChangeIbanService(ctx);
  const uploadPhotoService = new UploadPhotoService(ctx);
  const biometryService = new BiometryService(ctx);

  Vue.prototype.$requiredChangeIbanService = requiredChangeIbanService;
  Vue.prototype.$uploadPhotoService = uploadPhotoService;
  Vue.prototype.$biometryService = biometryService;

  inject('requiredChangeIbanService', requiredChangeIbanService);
  inject('uploadPhotoService', uploadPhotoService);
  inject('biometryService', biometryService);
}
